module.exports = __webpack_public_path__ + "static/media/download.3e24566d.svg";